module.exports = __webpack_public_path__ + "static/img/3.58140b9.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/1/zh/3.png
// module id = MU1j
// module chunks = 0